<template>
	<div class="tabs-form">
		<div class="tabs">
			<div v-for="item in identity" :key="item.id" @click="handlePrivateClick(item.id)"
				:class="['tabs-pane', tabId == item.id && 'tabs-pane-avtive']">
				{{ item.name }}
			</div>
		</div>

		<el-form :inline="true" class="form" ref="form" :model="form">
			<div class="form-contain">
				<el-form-item prop="fu_origin_filename">
					<InputTopTip v-model="form.fu_origin_filename" placeholder="名称">
						<el-input v-model="form.fu_origin_filename" size="small" class="width-264" placeholder=""
							@keyup.native.enter="; (page = 1), getFileStorage()"></el-input>
					</InputTopTip>
				</el-form-item>
				<el-form-item prop="fb_publisher_id">
					<InputTopTip v-model="form.fb_publisher_id" placeholder="出版社">
						<el-select v-model="form.fb_publisher_id" size="small" placeholder="" class="width-166"
							@change="formChange($event, '出版社')">
							<el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<!-- <el-form-item prop="fb_apply_grade">
					<el-select v-model="form.fb_apply_grade" size="small" placeholder="年级" class="width-166">
						<el-option v-for="item in all_grade" :key="item.val" :label="item.name" :value="item.val"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="fb_apply_volume">
					<el-select v-model="form.fb_apply_volume" size="small" placeholder="上下册" class="width-166">
						<el-option
							v-for="item in fb_apply_volume"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item prop="fb_textbook_id">
					<InputTopTip v-model="form.fb_textbook_id" placeholder="教材">
						<el-select v-model="form.fb_textbook_id" size="small" :disabled="!!!form.fb_publisher_id"
							placeholder="" class="width-166" @change="formChange($event, '教材')">
							<el-option v-for="item in textbookTags" :key="item.id" :label="item.text_name"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item prop="dict_ids">
					<InputTopTip v-model="form.dict_ids" placeholder="目录">
						<el-cascader :disabled="!!!form.fb_textbook_id" v-model="form.dict_ids" :props="{
							value: 'id',
							label: 'direct_name',
							expandTrigger: 'click'
						}" :options="dictIdTags" :show-all-levels="false" placeholder="" size="small" class="width-166"
							@change="formChange($event, '目录')"></el-cascader>
					</InputTopTip>
				</el-form-item>
				<el-form-item prop="fb_file_type">
					<InputTopTip v-model="form.fb_file_type" placeholder="类型">
						<el-select v-model="form.fb_file_type" size="small" placeholder="" class="width-166"
							@change="formChange($event, '类型')">
							<el-option v-for="item in fileType" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item prop="folder_name">
					<InputTopTip v-model="form.folder_name" placeholder="文件夹名称">
						<el-input v-model="form.folder_name" size="small" class="width-264" placeholder=""
							@keyup.native.enter="; (page = 1), getFileStorage()"></el-input>
					</InputTopTip>
				</el-form-item>
			</div>

			<el-form-item class="form-reset">
				<el-button type="primary" @click="; (page = 1), getFileStorage()" size="small" class="action-btn"
					style="width: 70px; margin-right: 15px;">搜索</el-button>
				<el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="table">
			<div class="table-header" v-if="$store.state.user.userInfo.type !== $api.account.types.SCHOOL_ADMIN.value">
				<div _flex="~">
					<el-button type="primary" @click="; (scopeType = 'new'), (newVisible = true)" size="small" v-if="
						($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
						($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
							tabId == 1 &&
							$permissions([`SP4400_${yy_ms}_2`]))
					">
						<i class="el-icon-plus" style="margin-right: 7px;"></i>新建
					</el-button>
				</div>

				<el-button v-if="
					(($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
						($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
							tabId == 1 &&
							$permissions([`SP4400_${yy_ms}_6`]))) &&
					multipleSelection.length >= 1
				" @click="deleteFileStorageAll" size="small" :disabled="multipleSelection.length <= 0"
					:style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'">
					<i class="el-icon-delete" style="margin-right: 7px;"></i>批量删除
				</el-button>
			</div>

			<el-table :data="tableData" stripe style="width: 100%; min-height: 570px;"
				@selection-change="handleSelectionChange" ref="multipleTable">
				<el-table-column type="selection" width="55" align="center" :key="'selection'" v-if="
					($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
					($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
					$store.state.user.userInfo.type === $api.account.types.RESEARCH.value
				"></el-table-column>
				<!-- 产品要求 -->
				<el-table-column label="编号" prop="id" :show-overflow-tooltip="true" width="60px">
					<template slot-scope="{ $index }">
						{{ $index + 1 + page_size * (page - 1) }}
					</template>
				</el-table-column>
				<el-table-column label="名称" prop="origin_filename" align="left">
					<template slot-scope="{ row }">
						<el-tooltip placement="top" effect="light" :content="row.origin_filename">
							<div>
								{{ row.origin_filename.length > 12 ? row.origin_filename.substr(0, 12) + '...' :
									row.origin_filename }}
							</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="类型" prop="file_type" align="left" width="80px">
					<template slot-scope="{ row }">
						{{`${fileType.find(item => item.id == row.file_type).name}`}}
					</template>
				</el-table-column>
				<el-table-column label="出版社" prop="publisher_id" align="left" width="120px">
					<template slot-scope="{ row }">
						{{`${publisherIdTags.find(item => item.id == row.publisher_id)?.name}` || '——'}}
					</template>
				</el-table-column>
				<el-table-column label="关联教材" prop="textbook" align="left" width="250px" :show-overflow-tooltip="true">
					<template slot-scope="{ row }">
						{{
							`${row.textbook.text_name} / ${filteName(row.textbook.text_classgrade, all_grade)} /
						${filteLabel(row.textbook.text_volume, fb_apply_volume)}`
						}}
					</template>
				</el-table-column>
				<el-table-column label="目录" prop="directory.direct_name" align="left"></el-table-column>
				<el-table-column label="文件夹" prop="folder.title" align="left"></el-table-column>
				<el-table-column label="创建人" prop="user.realname" align="left"></el-table-column>
				<el-table-column label="操作人" align="center" width="120px">
					<template slot-scope="{ row }">
						<template v-if="row.updator">{{ row.updator.realname }}</template>
						<template v-else>
							{{ row.user.realname }}
						</template>
					</template>
				</el-table-column>
				<el-table-column label="操作时间" prop="updated_at" width="180"></el-table-column>
				<el-table-column label="操作" align="center"
					v-if="$permissions([`SP4400_${yy_ms}_5`, `SP4400_${yy_ms}_3`, `SP4400_${yy_ms}_4`])">
					<template slot-scope="{ row }">
						<div style="display: flex; justify-content: center;">
							<!-- <el-tooltip placement="top" effect="light" v-if="$permissions([SP4400_yy_3]) || tabId == 0"> -->
							<el-tooltip placement="top" effect="light" v-permission="`SP4400_${yy_ms}_3`">
								<div slot="content">查看</div>
								<div class="icon-circle" style="background: white;" _border="1px solid [#ebeef5]"
									@click="routePush(row)">
									<i class="el-icon-view" style="color: #ff7143;"></i>
								</div>
							</el-tooltip>
							<el-tooltip placement="top" effect="light" v-if="
								($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
								($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
									tabId == 1 &&
									$permissions([`SP4400_${yy_ms}_4`]))
							">
								<div slot="content">编辑</div>
								<div class="icon-circle" style="color: #3f6af7; background: white;"
									_border="1px solid [#ebeef5]" @click="; (scopeType = 'edit'), editParamsEvent(row)">
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-iconoutlinesetting"></use>
									</svg>
									<!-- <i class="el-icon-edit-outline" style="color: #3f6af7;"></i> -->
								</div>
							</el-tooltip>

							<el-tooltip placement="top" effect="light" v-if="
								($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
								($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
									tabId == 1 &&
									$permissions([`SP4400_${yy_ms}_5`]))
							">
								<div slot="content">删除</div>
								<div class="icon-circle" @click="deleteParamsEvent(row)">
									<!-- <i class="el-icon-delete" style="color: #ff1f1f;"></i> -->
									<svg class="icon" aria-hidden="true"
										style="width: 100%; height: 100%; outline: none; box-shadow: none;">
										<use xlink:href="#icon-deltred"></use>
									</svg>
								</div>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="page_size"
					:total="total" background layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange" @size-change="handleSizeChange"
					:key="`${paginationKey}_${tabId}`">
				</el-pagination>
			</div>
		</div>
		<el-dialog class="scope-dialog" :width="'540px'" :before-close="beforeNewClose" :close-on-click-modal="false"
			:visible="newVisible" @close="beforeNewClose" :title="`${scopeType == 'new' ? '新建' : '编辑'}资源`">
			<el-divider></el-divider>
			<el-form :model="newParams" :rules="paramsRules" ref="newParams" label-width="100px">
				<el-form-item label="名称：" prop="origin_filename" v-if="scopeType == 'edit'">
					<InputTopTip v-model="newParams.origin_filename" placeholder="名称">
						<el-input v-model="newParams.origin_filename" oninput="value=value.trim()" size="small"
							class="width-264" :maxlength="50" placeholder=""></el-input>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="出版社：" prop="publisher_id">
					<InputTopTip v-model="newParams.publisher_id" placeholder="出版社">
						<el-select v-model="newParams.publisher_id" size="small" placeholder="" class="width-166"
							@change="scopeChange($event, '出版社')">
							<el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="关联教材：" prop="c" v-if="newParams.publisher_id">
					<InputTopTip v-model="newParams.c" placeholder="关联教材">
						<el-select v-model="newParams.c" size="small" placeholder="" class="width-166"
							@change="scopeChange($event, '教材')">
							<el-option v-for="item in textbook" :key="item.id" :label="item.text_name"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="目录：" prop="dict_ids" v-if="newParams.c">
					<InputTopTip v-model="newParams.dict_ids" placeholder="目录">
						<el-cascader v-model="newParams.dict_ids" :props="{
							value: 'id',
							label: 'direct_name',
							expandTrigger: 'click'
						}" :options="scopeOptions" :show-all-levels="false" placeholder="" size="small" class="width-166"
							@change="scopeChange($event, '目录')"></el-cascader>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="类型：" prop="file_type">
					<InputTopTip v-model="newParams.file_type" placeholder="类型">
						<el-select v-model="newParams.file_type" size="small" placeholder="" class="width-166"
							@change="scopeChange($event, '类型')">
							<el-option v-for="item in fileType" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="文件夹：" prop="folder_id"
					v-if="newParams.dict_ids?.length > 0 && newParams.file_type">
					<el-button type="info" size="small" _m="!b-10px" icon="el-icon-plus"
						@click="; (folder.visible = true), (folder.text = '')">添加文件夹</el-button>
					<div _m="!b-10px" _flex="~ items-center" v-if="folder.visible">
						<el-input v-model="folder.text" size="small" class="width-166"
							@keyup.native.enter="folderConfirm"></el-input>
						<i class="el-icon-success" _m="!l-5px" _cursor="pointer" _text="16px [green]"
							@click="folderConfirm"></i>
						<i class="el-icon-error" _m="!l-5px" _cursor="pointer" _text="16px [red]"
							@click="; (folder.visible = false), (folder.text = '')"></i>
					</div>
					<InputTopTip v-model="newParams.folder_id" placeholder="文件夹">
						<el-select v-model="newParams.folder_id" size="small" placeholder="" class="width-166"
							@change="scopeChange($event, '文件夹')">
							<el-option v-for="item in folder.ids" :key="item.id" :label="item.title"
								:value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item label="文件：" prop="path" v-if="newParams.file_type">
					<div _m="b-5px" v-if="fileList?.length >= 1" _flex="~ wrap">
						<div v-for="(item, index) in [...fileList]" :key="index" _pos="relative"
							:class="newParams.file_type == 3 ? 'scope-file-2' : 'scope-file'"
							_border="rounded-5px 1px solid [#cfd7e7]" _m="r-10px b-8px">
							<img :src="showImage(item)" @click="resourceVisibleClick(item)" _cursor="pointer" />
							<i class="el-icon-error" _pos="absolute" _right="-8px" _border="rounded-[100%]"
								_bg="[#FFFFFF]" _top="-8px" _cursor="pointer" _z="1" _text="18px [#cfd7e7]"
								@click="removeFile(index)"></i>
						</div>
					</div>
					<upload ref="uploadRef"
						v-if="(scopeType == 'new' && fileList.length < 9) || (scopeType == 'edit' && fileList.length < 1)"
						:accept="fileType.find(item => item.id == newParams.file_type).val"
						:multiple="scopeType == 'new'" :limit="scopeType == 'new' ? 999 : 1" :fileListShow="false"
						:drag="true" :fileUrlData="fileList" @customUpload="customUpload">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">
							将{{fileType.find(item => item.id == newParams.file_type).name}}拖到此处，或<em>点击上传</em>
						</div>
					</upload>
				</el-form-item>
			</el-form>
			<el-divider></el-divider>
			<div
				style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
				<el-button class="btn-close" @click="newVisible = false"
					style="width: 80px; height: 32px; line-height: 1px;">取
					消</el-button>
				<el-button class="btn-prim" type="primary" @click="boxConfirmEvent('newParams')"
					style="width: 80px; height: 32px; line-height: 1px;">确定</el-button>
			</div>
		</el-dialog>
		<!-- 资源查看 -->
		<el-dialog custom-class="video-dialog" :show-close="false" :visible.sync="audioFlag" :append-to-body="true"
			:width="'350px'" top="40vh">
			<div
				style="display: flex; justify-content: center; z-index: 2099; position: relative; margin-bottom: 10px;">
				<i class="el-icon-close" _cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="audioFlag = false"></i>
				<audio ref="audioFlag" @click.stop controls :src="audioResource"
					controlslist="noplaybackrate nodownload"></audio>
			</div>
		</el-dialog>
		<el-dialog custom-class="video-dialog" :show-close="false" :visible.sync="videoFlag" :append-to-body="true"
			:width="'509px'" top="32vh">
			<div
				style="display: flex; justify-content: center; align-items: center; z-index: 2099; position: relative;">
				<i class="el-icon-close" _cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="videoFlag = false"></i>
				<video ref="videoRef" @click.stop controls width="500" :src="videoResource"
					controlslist="noplaybackrate nodownload"></video>
			</div>
		</el-dialog>
		<el-dialog :show-close="false" :visible.sync="imgFlag" :append-to-body="true" width="620px">
			<div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
				<i class="el-icon-close" _cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;" @click="imgFlag = false"></i>
				<img :src="imgResource" style="max-width: 600px; max-height: 900px;" />
			</div>
		</el-dialog>
	</div>
</template>
<script>
import upload from './Upload.vue'
import {
	// SP4400_yy,
	SP4400_yy_1,
	SP4400_yy_2,
	SP4400_yy_3,
	SP4400_yy_4,
	SP4400_yy_5,
	// SP4400_ms,
	SP4400_ms_1,
	SP4400_ms_2,
	SP4400_ms_3,
	SP4400_ms_4,
	SP4400_ms_5
} from '@/utils/permissionMap.js'
import {
	fileType,
	fb_apply_volume,
	primarySchool,
	middleSchool,
	highSchool,
	all_grade,
	adminIdentity,
	teacherIdentity,
	schoolIdentity,
	researchIdentity
} from './const.js'
import { getFirstFrame } from './utils.js'
import { cloneDeep, last, mapValues } from 'lodash'
export default {
	components: {
		upload
	},
	data() {
		return {
			adminIdentity,
			teacherIdentity,
			schoolIdentity,
			researchIdentity,
			identity: [],
			publisherIdTags: [],
			textbook: [],
			scopeOptions: [],
			dictIdTags: [],
			textbookTags: [],
			folder: {
				ids: [],
				visible: false,
				text: ''
			},
			paramsRules: {
				origin_filename: [{ required: true, message: '名称不能为空', trigger: ['blur', 'change'] }],
				publisher_id: [{ required: true, message: '请选择出版社', trigger: ['blur', 'change'] }],
				c: [{ required: true, message: '请选择教材', trigger: ['blur', 'change'] }],
				dict_ids: [{ required: true, message: '请选择目录', trigger: ['blur', 'change'] }],
				// folder_id: [{ required: true, message: '请选择文件夹', trigger: ['blur', 'change'] }],
				file_type: [{ required: true, message: '请选择类型', trigger: ['blur', 'change'] }],
				path: [{ required: true, message: '请上传文件', trigger: ['blur', 'change'] }]
			},
			newParams: {
				origin_filename: '',
				publisher_id: '',
				c: '',
				dict_ids: [],
				file_type: '',
				path: [],
				folder_id: ''
			},
			form: {
				fu_origin_filename: '',
				fb_publisher_id: '',
				// fb_apply_grade: '',
				// fb_apply_volume: '',
				fb_file_type: '',
				fb_textbook_id: '',
				// fb_dict_id: '',
				dict_ids: [],
				folder_name: ''
			},
			page: 1,
			page_size: 10,
			fileList: [],
			fileType,
			lookVisible: false,
			newVisible: false,
			scopeType: 'new',
			imgFlag: false,
			audioFlag: false,
			videoFlag: false,
			videoResource: '',
			audioResource: '',
			imgResource: '',
			primarySchool,
			middleSchool,
			highSchool,
			fb_apply_volume,
			all_grade,
			SP4400_yy_1,
			SP4400_yy_2,
			SP4400_yy_3,
			SP4400_yy_4,
			SP4400_yy_5,
			SP4400_ms_1,
			SP4400_ms_2,
			SP4400_ms_3,
			SP4400_ms_4,
			SP4400_ms_5,
			last_page: '',
			total: 0,
			tabs: [],
			tabs_teacher: [],
			activeId: null,
			tabId: 1,
			tableData: [],
			multipleSelection: [],
			row: {},
			loading: false,
			paginationKey: new Date().getTime(),
			vModelChangeVisible: true
		}
	},
	async created() { },
	watch: {
		$route: {
			handler(val) {
				const { sbid } = this.$route.params
				this.activeId = sbid
				this.initPage()
			},
			immediate: true,
			deep: true
		},
		videoFlag: {
			handler(vla) {
				if (!vla) {
					this.$refs?.videoRef?.pause()
				}
			}
		},
		audioFlag: {
			handler(vla) {
				if (!vla) {
					this.$refs?.audioRef?.pause()
				}
			}
		}
	},
	methods: {
		removeFile(index) {
			this.fileList.splice(index, 1)
			this.$refs.uploadRef.$emit('remove-file', index)
		},
		async folderConfirm() {
			const { id } = await this.$request.source.addFileStorage({
				subject_id: this.activeId,
				dict_id: last(this.newParams.dict_ids),
				dict_ids: this.newParams.dict_ids,
				is_private: this.tabId,
				origin_filename: this.folder.text,
				file_type: this.newParams.file_type,
				is_folder: 1
			})

			this.form.dict_id = last(this.newParams.dict_ids)

			await this.getStorageFolder()
			this.newParams.folder_id = id
			this.folder.visible = false
		},
		handlePrivateClick(e) {
			this.getSearchParams(e)
			this.getPublisherId()
			this.getFileStorage()
		},
		async initPage() {
			await this.getPublisherId()
			const userInfo = this.$store.state.user.userInfo
			if (userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
				this.identity = this.schoolIdentity
			} else if (userInfo.type === this.$api.account.types.TEACHER.value) {
				this.identity = this.teacherIdentity
			} else if (userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				this.identity = this.adminIdentity
			} else if (userInfo.type === this.$api.account.types.RESEARCH.value) {
				this.identity = this.researchIdentity
			} else {
				this.identity = this.adminIdentity
			}
			// await this.getSubjectData()
			// this.tabId = this.$store.state.searchParams[`${this.$route.name}`]
			// if (this.tabId == undefined) { this.tabId = 1 }
			this.form = mapValues(this.form, () => '')
			this.getSearchParams()
			this.getFileStorage()
		},
		async getSearchParams(top = undefined) {
			this.vModelChangeVisible = true
			const searchParams = this.$store.state.searchParams[`${this.$route.name}_${this.activeId}`]
			if (top != undefined) {
				this.tabId = top
				this.page = searchParams[top]?.page || 1
				this.page_size = searchParams[top]?.page_size || 10
				this.form.fu_origin_filename = searchParams[top]?.fu_origin_filename
				this.form.fb_publisher_id = searchParams[top]?.fb_publisher_id
				this.form.fb_textbook_id = searchParams[top]?.fb_textbook_id
				this.form.fb_file_type = searchParams[top]?.fb_file_type
				this.form.dict_ids = searchParams[top]?.dict_ids
				this.form.folder_name = searchParams[top]?.folder_name
			} else {
				try {
					const { historyTop } = searchParams
					this.tabId = historyTop
					this.page = searchParams[historyTop]?.page || 1
					this.page_size = searchParams[historyTop]?.page_size || 10
					this.form.fu_origin_filename = searchParams[historyTop]?.fu_origin_filename
					this.form.fb_publisher_id = searchParams[historyTop]?.fb_publisher_id
					this.form.fb_textbook_id = searchParams[historyTop]?.fb_textbook_id
					this.form.fb_file_type = searchParams[historyTop]?.fb_file_type
					this.form.dict_ids = searchParams[historyTop]?.dict_ids
					this.form.folder_name = searchParams[top]?.folder_name
				} catch (err) {
					console.log('正常~')
					this.tabId = this.identity[0]?.id
					this.page = 1
					this.page_size = 10
				}
			}
			setTimeout(() => {
				this.vModelChangeVisible = false
			}, 0)
			this.paginationKey = new Date().getTime()

			// select是动态的、需要保存额外字段
			if (this.form.fb_publisher_id) {
				await this.getTextbooks(this.form.fb_publisher_id, 'textbookTags')
				if (this.form.fb_textbook_id) {
					let book = this.textbookTags.find(item => item.id == this.form.fb_textbook_id)
					const options = this.removeEmptyItems(book?.directory, 'children')
					this.dictIdTags = options
				}
			}
		},
		resourceVisibleClick(item) {
			switch (this.newParams.file_type) {
				case 'image' | 1:
					this.imgResource = item.uri
					this.imgFlag = true
					break
				case 'audio' | 2:
					this.audioResource = item.uri
					this.audioFlag = true
					break
				case 'video' | 3:
					this.videoResource = item.uri
					this.videoFlag = true
					break
				default:
			}
		},
		beforeNewClose() {
			this.newVisible = false
			this.fileTypeChange()
			this.newParams = {
				origin_filename: '',
				publisher_id: '',
				c: '',
				dict_ids: [],
				file_type: '',
				path: [],
				folder_id: ''
			}
			this.$refs['newParams'].resetFields()
		},
		fileTypeChange(event) {
			this.fileList.splice(0, this.fileList.length)
			this.newParams.path.splice(0, this.newParams.path.length)
		},
		boxConfirmEvent(formName) {
			this.$refs[formName].validate(async valid => {
				if (valid) {
					if (this.scopeType == 'new') {
						// delete this.newParams.origin_filename
						const promises = this.fileList.map(file =>
							this.$request.source.addFileStorage({
								...this.newParams,
								origin_filename: file.name,
								is_private: this.tabId,
								path: file.node,
								subject_id: this.activeId,
								dict_id: last(this.newParams.dict_ids)
							})
						)
						await Promise.all(promises)
						this.$message.success('新建成功，请刷新数据')
					} else if (this.scopeType == 'edit') {
						await this.$api.resource.editFileStorageDetail(this.row.id, {
							...this.newParams,
							path: last(this.fileList).node,
							subject_id: this.activeId,
							dict_id: last(this.newParams.dict_ids)
						})
						this.$message.success('更新成功，请刷新数据')
					}
					this.getFileStorage()
					this.beforeNewClose()
				} else {
					return false
				}
			})
		},
		async editParamsEvent(row) {
			this.row = row
			const data = await this.$api.resource.getFileStorageDetail(row.id)
			await this.getTextbooks(data.publisher_id)
			let book = this.textbook.find(item => item.id == data.textbook_id)
			try {
				const options = this.removeEmptyItems(book?.directory, 'children')
				this.scopeOptions = options
			} catch (err) {
				console.error(err)
				this.$message.error('教材目录获取异常')
				return
			}
			this.newParams = {
				origin_filename: data.origin_filename,
				c: data.textbook_id,
				file_type: data.file_type,
				publisher_id: data.publisher_id,
				dict_ids: data.dict_ids,
				textbook_id: data.textbook_id,
				path: [
					{
						uri: data.path.url,
						node: data.path.node
					}
				]
			}
			if (data.file_type == 3) {
				const imgUrl = await getFirstFrame(data.path.url)
				this.fileList.push({ uri: data.path.url, node: data.path.node, cover: imgUrl })
			} else {
				this.fileList.push({ uri: data.path.url, node: data.path.node })
			}
			await this.getStorageFolder()
			this.newParams.folder_id = data.folder_id == 0 ? '' : data.folder_id
			this.newVisible = true
		},
		async getFileStorage(folder = 0) {
			const params = {
				...this.form,
				fb_dict_id: last(this.form.dict_ids),
				scope_type: this.tabId,
				fb_subject_id: this.activeId,
				page_size: this.page_size,
				page: this.page,
				is_folder: folder
			}
			// this.$store.commit('setTabSearchParams', { key: `${this.$route.name}_${this.tabId}`, top: this.activeId, params: params })
			this.$store.commit('setTabSearchParams', {
				key: `${this.$route.name}_${this.activeId}`,
				top: this.tabId,
				params: params
			})
			const data = await this.$api.resource.getFileStorage(params)
			this.tableData = data.data
			this.total = data.meta.total
			this.last_page = data.meta.last_page
		},
		async getPublisherId() {
			const { data } = await this.$api.question_set.getPublisherId({
				fb_subject_id: this.activeId,
				scope_type: this.tabId
			})
			this.publisherIdTags = data
		},
		async getTextbooks(publisherId, argsName = 'textbook') {
			const { data } = await this.$api.resource.getTextbooks({
				fb_subject_id: this.activeId,
				fb_publisher_id: publisherId,
				page_size: 99,
				page: 1,
				// scope_type: this.tabId
				scope_type: this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value ? 0 : this.tabId
			})
			this[argsName] = data
		},
		async scopeChange(event, type) {
			switch (type) {
				case '出版社':
					this.$set(this.newParams, 'publisher_id', event)
					this.$set(this.newParams, 'c', '')
					this.$set(this.newParams, 'dict_ids', [])
					this.getTextbooks(event)
					break
				case '教材': {
					this.$set(this.newParams, 'c', event)
					this.$set(this.newParams, 'dict_ids', [])
					let book = this.textbook.find(item => item.id == event)
					const options = this.removeEmptyItems(book?.directory, 'children')
					this.scopeOptions = options
					break
				}
				case '目录': {
					this.$set(this.newParams, 'dict_ids', event)
					await this.getStorageFolder()
					break
				}
				case '类型': {
					this.fileTypeChange(event)
					await this.getStorageFolder()
					break
				}
				case '文件夹': {
					this.newParams.folder_id = event
					this.$set(this.newParams, 'folder_id', event)
					break
				}
			}
		},
		async getStorageFolder() {
			this.$set(this.newParams, 'folder_id', '')
			const { data } = await this.$api.resource.getFileStorage({
				fb_dict_id: this.newParams.dict_ids?.length > 0 ? last(this.newParams.dict_ids) : '',
				page_size: 100,
				file_type: this.newParams.file_type,
				subject_id: this.activeId,
				is_folder: 1,
				scope_type: this.tabId
			})
			this.folder.ids = data
			// 傻逼逻辑，文件夹被删除，但是资源还在，导致文件夹只展示id，需要手动改成空
			setTimeout(() => {
				const valid = this.folder.ids.some(item => item.id == this.newParams.folder_id)
				if (!valid) this.folder.ids.push({ id: this.newParams.folder_id, title: '   ' })
			}, 100)
		},
		formChange(event, type) {
			if (this.vModelChangeVisible) return
			switch (type) {
				case '出版社':
					this.getTextbooks(event, 'textbookTags')
					this.$set(this.form, 'fb_textbook_id', '')
					this.$set(this.form, 'dict_ids', [])
					break
				case '教材': {
					this.$set(this.form, 'dict_ids', [])
					let book = this.textbookTags.find(item => item.id == event)
					const options = this.removeEmptyItems(book?.directory, 'children')
					this.dictIdTags = options
					break
				}
				case '目录':
					break
			}
			this.getFileStorage()
		},
		async deleteFileStorageAll() {
			if (this.multipleSelection.length <= 0) return
			const params = this.multipleSelection.map(item => {
				return item.id
			})
			const quotedNames = this.multipleSelection
				.filter(item => item.is_used)
				.map(item => item.origin_filename)
				.join('、')
			this.$confirm(
				quotedNames
					? `<b style="color:red">${quotedNames}</b> 资源已被其他课件引用, 删除后将会对其他课件产生影响，是否继续?`
					: '此操作将永久删除, 是否继续?',
				'温馨提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					dangerouslyUseHTMLString: true,
					type: 'warning'
				}
			)
				.then(async () => {
					await this.$api.resource.deleteFileStorageAll({
						ids: params
					})
					this.page = 1
					this.getFileStorage()
				})
				.catch(() => { })
		},
		async twoConfirmClick() {
			this.loading = true
			const data = await this.$api.resource.deleteFileStorageDetail(this.row.id)
			if (data.success) {
				// 因为存在那种勾选但是还是点击删除的情况，需要手动删掉
				const index = this.multipleSelection.findIndex(item => item.id === this.row.id)
				this.multipleSelection.splice(index, 1)
				this.loading = false
				this.getFileStorage()
			} else {
				console.log('error')
			}
		},
		deleteParamsEvent(row) {
			this.row = row
			this.$confirm(
				row.is_used ? `该资源已被其他课件引用, 删除后将会对其他课件产生影响，是否继续?` : `此操作将永久删除, 是否继续?`,
				'温馨提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					dangerouslyUseHTMLString: true,
					type: 'warning'
				}
			).then(async () => {
				await this.twoConfirmClick()
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleTabClick(e) {
			this.getSearchParams(e)
			this.getFileStorage()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.form = mapValues(this.form, () => '')
			this.getFileStorage()
		},
		routePush(row) {
			const params = {
				origin_filename: row?.origin_filename, // 素材名称
				publisher: row?.publisher?.name, // 出版社名称
				text_name: row?.textbook?.text_name, // 课件名称
				text_classgrade: this.filteName(row?.textbook?.text_classgrade, this.all_grade), // 关联教材年级
				text_volume: this.filteLabel(row?.textbook?.text_volume, this.fb_apply_volume), // 关联教材上下册
				direct_name: row?.directory?.direct_name, // 目录名称
				file_type: this.fileType.find(item => item.id == row.file_type).name, // 类型
				folder: row?.folder?.title, // 文件夹名称
				path: row?.path?.url // 资源链接
			}
			window.localStorage.setItem('sourceDetailManagement', JSON.stringify(params))
			this.$router.push({
				// path: '/workbench/sourceDetailManagement',
				name: 'sourceDetailManagement',
				query: {
					id: row.id,
					scope_type: this.tabId
				}
			})
		},
		// 更改条数
		handleSizeChange(val) {
			this.page = 1
			this.page_size = val
			this.getFileStorage()
		},
		// 更改页码
		handleCurrentChange(val) {
			this.page = val
			this.getFileStorage()
		},
		showImage(item) {
			return this.newParams.file_type == 1
				? item.uri
				: this.newParams.file_type == 3
					? item.cover
					: require('@/assets/image/audio.jpg')
		},
		removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.children?.length >= 1) {
					item.children = this.removeEmptyItems(item.children)
				} else {
					item.children = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		filteLabel(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.value === value)]?.label || '——'
		},
		filteName(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.val === value)]?.name || '——'
		},
		// 上传成功之后的回调,获取到链接
		async customUpload({ response, name }) {
			if (this.newParams.file_type == 3) {
				// 获取视频第一帧作为展示图
				const imgUrl = await getFirstFrame(response.uri)
				this.fileList.push({ ...response, cover: imgUrl, name })
			} else {
				this.fileList.push({ ...response, name })
			}
			this.newParams.path = cloneDeep(this.fileList)
		}
	},
	computed: {
		yy_ms() {
			return this.activeId == 1 ? 'yy' : this.activeId == 2 ? 'ms' : ''
		}
	}
}
</script>
<style scoped lang="scss">
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}

.tabs-form {
	min-height: 102px;
	border-radius: 8px 8px 8px 8px;
	opacity: 1;
}

.table {
	margin-top: 10px;
	padding: 20px;
	background: #ffffff;
	display: block;
}

/deep/ .el-table tbody tr td:last-child {
	padding-right: 0 !important;
}

.table-button {
	margin: 0;
}

.scope-dialog {
	/deep/ .el-dialog .el-dialog__header {
		padding-bottom: 0px;
	}

	.scope-file {
		display: flex;
		flex-wrap: wrap;
		width: 50px;

		img {
			width: 50px;
			object-fit: contain;
		}
	}

	.scope-file-2 {
		display: flex;
		flex-wrap: wrap;
		width: 150px;

		img {
			width: 150px;
      min-height: 50px;
			object-fit: contain;
		}
	}
}

.video-dialog {
	margin-top: 25vh;
}

.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}

.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.icon-circle:nth-child(2) {
	margin-left: 15px;
	margin-right: 15px;
}

.table-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

.tabs {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
	height: 39px;
	background: #ffffff;
}

.tabs-pane-avtive {
	color: #4a4a4a !important;
	position: relative;
}

.tabs-pane-avtive::after {
	content: '';
	display: block;
	position: absolute;
	top: 38px;
	width: 43px;
	height: 2px;
	background: #ff5e2a;
	border-radius: 0px 0px 0px 0px;
}

.tabs-pane {
	margin-left: 17px;
	margin-right: 8px;
	width: 36px;
	height: 39px;
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #bbbbbb;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}

.form-contain {
	flex-basis: 80%;

	/deep/ .el-form-item {
		margin-bottom: 12px;
	}
}

.form-reset {
	display: flex;
	flex-wrap: nowrap;
}

.width-166 {
	width: 166px;
}

.width-264 {
	width: 264px;
}

// 少婷提的——表格80
/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
</style>
